import React, { useMemo, useContext } from 'react';
import { debounce } from 'underscore';

import {
  WEBSITE_SOURCE_DATA_KEY_MAPPING,
  getWebsiteSourceDataByKey,
} from '@bingads-webui-campaign-react/smart-component-util';
import { useContextLocale } from '@bingads-webui-campaign-react/smart-page-data-service';
import { useClientContext } from './client-context';

export const SiteConfigContext = React.createContext({
  siteConfig: null,
  dispatchSiteConfig: () => { },
});

export const useSiteConfig = () => {
  const contextValue = useContext(SiteConfigContext);
  return contextValue;
};

export const useDebouncedDispatchSiteConfig = (wait = 10) => {
  const { dispatchSiteConfig } = useSiteConfig();
  const debounced = useMemo(() => debounce(dispatchSiteConfig, wait), [dispatchSiteConfig, wait]);

  return debounced;
};

export const SavedSiteConfigContext = React.createContext({
  savedSiteConfig: null,
  updateSavedSiteConfig: () => { },
});

export const useSavedSiteConfig = () => {
  const contextValue = useContext(SavedSiteConfigContext);
  return contextValue;
};

export const useSiteConfigLocale = () => {
  const { siteConfig } = useSiteConfig();

  return getWebsiteSourceDataByKey(siteConfig, WEBSITE_SOURCE_DATA_KEY_MAPPING.Localization);
};

export const useCurrentLocale = () => {
  const { isRuntime } = useClientContext();

  const siteConfigLocale = useSiteConfigLocale();
  const contextLocale = useContextLocale();

  // In runtime page we need to read locale from WSD first, otherwise we read from browser
  if (isRuntime) {
    return siteConfigLocale || contextLocale;
  }

  return contextLocale || siteConfigLocale;
};
